if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
        // モバイルで商品詳細ページのピンチズームを無効化
        if (window.innerWidth <= 749 && document.body.classList.contains('template-product')) {
          document.body.style.touchAction = 'manipulation';
          document.documentElement.style.touchAction = 'manipulation';
        }
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
        // モバイルでモーダル内のみピンチズームを有効化
        if (window.innerWidth <= 749) {
          document.body.style.touchAction = 'pan-x pan-y pinch-zoom';
          document.documentElement.style.touchAction = 'pan-x pan-y pinch-zoom';
        }
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
